import { render, staticRenderFns } from "./CTableDataCell.vue?vue&type=template&id=313ce978&scoped=true&"
import script from "./CTableDataCell.vue?vue&type=script&lang=ts&"
export * from "./CTableDataCell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313ce978",
  null
  
)

export default component.exports